/* FLAIRIDE theme — minimal vanilla JS for interactivity.
 * No frameworks. Progressive enhancement.
 * Hooks: data-cart-open, data-cart-close, data-mobile-menu-open,
 *        data-mega-trigger, data-carousel, data-faq-toggle,
 *        data-newsletter-form, data-promo-dismiss
 */
(function () {
  'use strict';

  // ---------- Promo strip: clear any previously stored "dismissed" flag
  //                       (banner is now permanent, no X button) ----------
  try { localStorage.removeItem('flairide:promo:dismissed'); } catch (_) {}

  // ---------- Hero slideshow auto-rotate ----------
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var texts  = hero.querySelectorAll('[data-hero-text]');
    var nums   = hero.querySelectorAll('[data-hero-num]');
    var trackEl = hero.querySelector('.hero-pagination .track');
    var interval = parseInt(hero.getAttribute('data-interval') || '5000', 10);
    if (slides.length <= 1) return;
    var segment = 100 / slides.length;
    if (trackEl) trackEl.style.setProperty('--track-h', segment + '%');
    var idx = 0;
    var timer = null;
    function setIdx(newIdx) {
      idx = ((newIdx % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.style.opacity = i === idx ? '1' : '0'; });
      texts.forEach(function (t, i) { t.style.display = i === idx ? 'flex' : 'none'; });
      nums.forEach(function (n, i) { n.classList.toggle('active', i === idx); });
      if (trackEl) trackEl.style.setProperty('--track-top', (idx * segment) + '%');
    }
    function start() {
      stop();
      timer = setInterval(function () { setIdx(idx + 1); }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    nums.forEach(function (n) {
      n.addEventListener('click', function () {
        var i = parseInt(n.getAttribute('data-idx'), 10) || 0;
        setIdx(i); start();
      });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  });

  // ---------- Header transparent → solid on scroll ----------
  var hdr = document.querySelector('[data-header]');
  if (hdr && hdr.classList.contains('transparent')) {
    var onScroll = function () {
      if (window.scrollY > 80) hdr.classList.add('solid');
      else hdr.classList.remove('solid');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Mega menu (hover open, grace-delay close) ----------
  var megaTriggers = document.querySelectorAll('[data-mega-trigger]');
  var megaPanel = document.querySelector('[data-mega-panel]');
  var megaCloseTimer = null;
  var megaReposition = null;
  function positionMega() {
    // Keep the panel flush under the header's CURRENT bottom edge. At the top
    // of the page the promo strip sits above the header (bottom ~110px); once
    // scrolled it docks to the top (bottom 72px). Because the panel is fixed,
    // we must recompute on scroll/resize or a gap opens as the promo scrolls
    // away. (That stale-top gap was the reported bug.)
    if (!megaPanel) return;
    var hdr = document.querySelector('.section-header') || document.querySelector('[data-header]') || document.querySelector('.header');
    if (hdr) megaPanel.style.top = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) + 'px';
  }
  function closeMega() {
    if (megaPanel) megaPanel.removeAttribute('data-open');
    document.documentElement.removeAttribute('data-mega-open');
    if (megaReposition) {
      window.removeEventListener('scroll', megaReposition);
      window.removeEventListener('resize', megaReposition);
      megaReposition = null;
    }
  }
  function openMega() {
    if (!megaPanel) return;
    clearTimeout(megaCloseTimer);
    positionMega();
    megaPanel.setAttribute('data-open', '');
    document.documentElement.setAttribute('data-mega-open', '');
    // Track the header position while open so the panel stays glued to it.
    if (!megaReposition) {
      megaReposition = function () { positionMega(); };
      window.addEventListener('scroll', megaReposition, { passive: true });
      window.addEventListener('resize', megaReposition);
    }
  }
  function scheduleCloseMega() {
    // Grace delay so the cursor can travel from the nav link down into the
    // panel without the menu flickering shut.
    clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(closeMega, 180);
  }
  megaTriggers.forEach(function (t) {
    t.addEventListener('mouseenter', function () {
      if (!megaPanel || !megaPanel.querySelector('[data-mega-rail-item]')) return;
      openMega();
    });
    t.addEventListener('mouseleave', scheduleCloseMega);
    // Click still navigates to the catalogue page (no preventDefault).
  });
  if (megaPanel) {
    megaPanel.addEventListener('mouseenter', function () { clearTimeout(megaCloseTimer); });
    megaPanel.addEventListener('mouseleave', scheduleCloseMega);
  }
  document.addEventListener('click', function (e) {
    if (megaPanel && megaPanel.hasAttribute('data-open')) {
      if (!e.target.closest('[data-mega-panel]') && !e.target.closest('[data-mega-trigger]')) {
        closeMega();
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });

  // Mega rail hover-to-switch
  document.querySelectorAll('[data-mega-rail-item]').forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      var coll = item.getAttribute('data-coll');
      document.querySelectorAll('[data-mega-rail-item]').forEach(function (i) { i.classList.toggle('active', i === item); });
      document.querySelectorAll('[data-mega-pane]').forEach(function (p) {
        p.hidden = p.getAttribute('data-coll') !== coll;
      });
    });
  });

  // ---------- Cart drawer ----------
  var drawer = document.querySelector('[data-cart-drawer]');
  var scrim = document.querySelector('[data-cart-scrim]');
  function openCart() {
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('data-open', '');
    if (scrim) { scrim.removeAttribute('hidden'); scrim.setAttribute('data-open', ''); }
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    drawer.setAttribute('hidden', '');
    if (scrim) { scrim.removeAttribute('data-open'); scrim.setAttribute('hidden', ''); }
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); refreshCart(); }
    if (e.target.closest('[data-cart-close]') || e.target === scrim) closeCart();
  });

  // ---------- Cart helpers ----------
  function money(cents) {
    var euros = (cents / 100);
    var parts = euros.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var dec = parts[1] === '00' ? '' : ',' + parts[1];
    return whole + dec + ' €';
  }

  var FREE_SHIPPING_THRESHOLD = 5000; // 50 € in cents — must match cart-drawer.liquid

  function tFromHTML() {
    // Read translated strings out of the initial server-rendered drawer
    // (lets us reuse Shopify's locale files instead of duplicating them
    // here). Falls back to French defaults if the elements aren't present.
    var d = drawer;
    return {
      subtotal:           (d && d.querySelector('[data-cart-subtotal]'))?.previousElementSibling?.textContent || 'Sous-total',
      shipping_free:      'Offerte',
      shipping_calc:      'Calculée à la commande',
      total:              'Total',
      remove:             'Retirer',
      decrease:           'Diminuer la quantité',
      increase:           'Augmenter la quantité',
      empty:              'Votre panier est vide.',
      continue_shopping:  'Continuer mes achats',
      remaining_html:     'Plus que <b>{0}</b> pour la livraison gratuite',
      reached:            'Livraison gratuite débloquée !'
    };
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var T = tFromHTML();
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var footEl  = drawer.querySelector('[data-cart-foot]');
    var countEl = drawer.querySelector('[data-cart-count-inline]');
    var subEl   = drawer.querySelector('[data-cart-subtotal]');
    var shipEl  = drawer.querySelector('[data-cart-shipping]');
    var totEl   = drawer.querySelector('[data-cart-total]');
    var fillEl  = drawer.querySelector('[data-cart-progress-fill]');
    var msgEl   = drawer.querySelector('[data-cart-progress-msg]');
    if (!itemsEl || !footEl) return;

    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    if (cart.item_count === 0) {
      itemsEl.innerHTML = ''
        + '<div class="drawer-empty" data-cart-empty>'
        +   '<p>' + T.empty + '</p>'
        +   '<a href="/collections/all" class="btn btn-secondary" data-cart-close>' + T.continue_shopping + '</a>'
        + '</div>';
      footEl.setAttribute('hidden', '');
      if (fillEl) fillEl.style.width = '0%';
      if (msgEl)  msgEl.innerHTML = T.remaining_html.replace('{0}', money(FREE_SHIPPING_THRESHOLD));
      return;
    }
    footEl.removeAttribute('hidden');

    // Items
    itemsEl.innerHTML = cart.items.map(function (it) {
      var img = it.image || it.featured_image && it.featured_image.url || '';
      var imgUrl = img ? (img.replace(/(\.[a-z]+)(\?.*)?$/, '_160x$1$2')) : '';
      var coll = (it.product_type || '');
      var optTitle = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="opt">' + it.variant_title + '</div>' : '';
      return ''
        + '<div class="drawer-item" data-line-item data-line-key="' + it.key + '">'
        +   '<a href="' + it.url + '" class="img" data-cart-close>'
        +     (imgUrl ? '<img src="' + imgUrl + '" alt="' + (it.product_title || '') + '" width="80" height="80" loading="lazy">' : '')
        +   '</a>'
        +   '<div class="drawer-item-body">'
        +     (coll ? '<div class="meta-eb">' + coll + '</div>' : '')
        +     '<a href="' + it.url + '" class="drawer-item-title" data-cart-close><h6>' + it.product_title + '</h6></a>'
        +     optTitle
        +     '<div class="drawer-item-bottom">'
        +       '<div class="qty">'
        +         '<button type="button" class="qty-btn" data-cart-change data-line-key="' + it.key + '" data-line-qty="' + (it.quantity - 1) + '" aria-label="' + T.decrease + '">−</button>'
        +         '<span data-line-qty-display>' + it.quantity + '</span>'
        +         '<button type="button" class="qty-btn" data-cart-change data-line-key="' + it.key + '" data-line-qty="' + (it.quantity + 1) + '" aria-label="' + T.increase + '">+</button>'
        +       '</div>'
        +       '<button type="button" class="drawer-item-remove" data-cart-change data-line-key="' + it.key + '" data-line-qty="0" aria-label="' + T.remove + '">' + T.remove + '</button>'
        +     '</div>'
        +   '</div>'
        +   '<div class="price">' + money(it.final_line_price) + '</div>'
        + '</div>';
    }).join('');

    // Totals
    if (subEl)  subEl.textContent = money(cart.total_price);
    if (totEl)  totEl.textContent = money(cart.total_price);
    if (shipEl) shipEl.textContent = cart.total_price >= FREE_SHIPPING_THRESHOLD ? T.shipping_free : T.shipping_calc;

    // Progress
    var pct = Math.min(100, Math.round(cart.total_price * 100 / FREE_SHIPPING_THRESHOLD));
    if (fillEl) fillEl.style.width = pct + '%';
    if (msgEl) {
      if (cart.total_price >= FREE_SHIPPING_THRESHOLD) {
        msgEl.textContent = T.reached;
      } else {
        var remain = FREE_SHIPPING_THRESHOLD - cart.total_price;
        msgEl.innerHTML = T.remaining_html.replace('{0}', money(remain));
      }
    }
  }

  // Fetch cart and update drawer
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        var ev = new CustomEvent('cart:updated', { detail: cart });
        document.dispatchEvent(ev);
        // Update badge
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  // Change a line item's quantity (or remove it when qty=0)
  function changeLine(key, qty) {
    if (drawer) drawer.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, parseInt(qty, 10) || 0) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (drawer) drawer.classList.remove('is-loading');
        renderDrawer(cart);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {
        if (drawer) drawer.classList.remove('is-loading');
      });
  }

  // Delegated click handler for cart drawer qty +/- and remove buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.getAttribute('data-line-key'), btn.getAttribute('data-line-qty'));
  });

  // PDP quantity selector +/- buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var step  = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
    var input = btn.parentElement.querySelector('[data-qty-input]');
    if (!input) return;
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // PDP: hide the Buy Now wrapper if Shopify rendered nothing inside it.
  // Without this, browsers without :has() support show an empty grid cell
  // and the "Ajouter au panier" button is stuck at half-width.
  document.querySelectorAll('.pdp-cta-buynow').forEach(function (el) {
    // Wait a tick — Shopify injects the Shop Pay / Klarna button async.
    setTimeout(function () {
      var hasButtons = el.querySelector('button, .shopify-payment-button__button');
      if (!hasButtons) {
        el.style.display = 'none';
        var addBtn = el.parentElement.querySelector('.pdp-cta-add');
        if (addBtn) addBtn.style.flex = '1 1 100%';
      }
    }, 600);
  });

  // Async add-to-cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCart();
        openCart();
      })
      .catch(function () { form.submit(); });
  });

  refreshCart();

  // ---------- Carousels (single-row, snap) ----------
  // Desktop (.carousel-track is overflow:hidden): translateX the inner flex
  // track — original behavior. Mobile (CSS makes .carousel-track a native
  // overflow-x scroller and forces .ct-inner{transform:none !important}): the
  // transform can't move anything, so scroll the real container by one card-step
  // and read the counter back from the live scroll position (so manual swipes
  // update it too). Gated on COMPUTED overflow-x so desktop never enters mobile mode.
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]'); // .ct-inner
    var scroller = track ? track.parentElement : null;           // .carousel-track
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var nav = carousel.querySelector('.carousel-nav');
    var pag = carousel.querySelector('[data-carousel-pagination]');
    var visible = parseInt(carousel.getAttribute('data-visible') || '3', 10);
    var total = track ? track.children.length : 0;
    var idx = 0;

    // True only on mobile: the <=768px CSS makes .carousel-track a real
    // horizontal scroller (overflow-x:auto/scroll) AND it overflows. On desktop
    // .carousel-track is overflow:hidden, so even though the flex cards overflow
    // (scrollWidth > clientWidth), overflowX is 'hidden' → returns false → the
    // original transform path runs.
    function isNative() {
      if (!scroller) return false;
      var ox = getComputedStyle(scroller).overflowX;
      return (ox === 'auto' || ox === 'scroll') &&
             scroller.scrollWidth > scroller.clientWidth + 1;
    }

    // Pixel step from one card to the next: real card width + the live flex gap.
    function stepSize() {
      var first = track && track.children[0];
      if (!first) return 0;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function pageCount() {
      if (isNative()) {
        var step = stepSize();
        var maxLeft = scroller.scrollWidth - scroller.clientWidth;
        if (step <= 0 || maxLeft <= 0) return 1;
        return Math.max(1, Math.ceil(maxLeft / step) + 1);
      }
      return Math.max(1, total - visible + 1);
    }

    function paint(page, pages, atStart, atEnd) {
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (!pag) return;
      var b = pag.querySelector('b');
      if (b) b.textContent = String(page).padStart(2, '0');
      var mute = pag.querySelector('.mute');
      if (mute) mute.textContent = String(pages).padStart(2, '0');
      var trackEl = pag.querySelector('.track');
      if (trackEl) trackEl.style.setProperty('--cprog', Math.round(page / pages * 100) + '%');
    }

    // Mobile: recompute counter + arrow state from the live scroll position.
    function syncFromScroll() {
      var step = stepSize();
      var pages = pageCount();
      var page = step > 0 ? Math.round(scroller.scrollLeft / step) + 1 : 1;
      page = Math.max(1, Math.min(pages, page));
      var maxLeft = scroller.scrollWidth - scroller.clientWidth;
      paint(page, pages, scroller.scrollLeft <= 1, scroller.scrollLeft >= maxLeft - 1);
    }

    // Desktop: original translateX behavior + original pagination math.
    function syncTransform() {
      var firstChild = track.children[0];
      if (firstChild) {
        var step = firstChild.getBoundingClientRect().width + 24;
        track.style.transform = 'translateX(' + (-idx * step) + 'px)';
      }
      var pages = Math.max(1, total - visible + 1);
      paint(idx + 1, pages, idx <= 0, idx >= Math.max(0, total - visible));
    }

    function update() {
      if (!track) return;
      // Show the arrows only when the row actually overflows the current viewport:
      // mobile shows ~1 card so even 2 products need them; desktop hides them when
      // everything fits (the Liquid renders the nav for any total > 1, JS decides).
      if (nav) {
        var overflows = isNative()
          ? (scroller.scrollWidth - scroller.clientWidth > 1)
          : (total > visible);
        nav.style.display = overflows ? '' : 'none';
      }
      if (isNative()) syncFromScroll();
      else syncTransform();
    }

    if (prev) prev.addEventListener('click', function () {
      if (isNative()) { scroller.scrollBy({ left: -stepSize(), behavior: 'smooth' }); }
      else { idx = Math.max(0, idx - 1); update(); }
    });
    if (next) next.addEventListener('click', function () {
      if (isNative()) { scroller.scrollBy({ left: stepSize(), behavior: 'smooth' }); }
      else { idx = Math.min(total - visible, idx + 1); update(); }
    });

    // Manual swipes (mobile) move the counter too. rAF-throttled.
    if (scroller) {
      var rafPending = false;
      scroller.addEventListener('scroll', function () {
        if (!isNative() || rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () { rafPending = false; syncFromScroll(); });
      }, { passive: true });
    }

    window.addEventListener('resize', update);
    window.addEventListener('load', update); // re-evaluate once images settle scrollWidth
    update();
  });

  // ---------- FAQ accordion ----------
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-faq-toggle]');
    if (!trigger) return;
    var item = trigger.closest('.faq-item');
    if (!item) return;
    item.classList.toggle('open');
  });

  // ---------- Mobile menu drawer (burger toggles open/closed; tap on a link closes) ----------
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-open]')) {
      e.preventDefault();
      var open = document.documentElement.getAttribute('data-mobile-menu') === 'open';
      if (open) document.documentElement.removeAttribute('data-mobile-menu');
      else document.documentElement.setAttribute('data-mobile-menu', 'open');
      return;
    }
    if (e.target.closest('[data-mobile-menu-close]')) {
      document.documentElement.removeAttribute('data-mobile-menu');
      return;
    }
    if (document.documentElement.getAttribute('data-mobile-menu') === 'open' && e.target.closest('.nav-link')) {
      document.documentElement.removeAttribute('data-mobile-menu');
    }
  });

  // ---------- PDP gallery: thumbs + prev/next arrows ----------
  document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main-img]');
    if (!mainImg) return;
    var thumbs  = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');

    function activate(idx) {
      if (!thumbs.length) return;
      // Wrap around the ends so arrows feel like a carousel
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      var thumb = thumbs[idx];
      if (!thumb) return;
      var src = thumb.getAttribute('data-img-large');
      if (src) mainImg.src = src;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function currentIndex() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('active')) return i;
      return 0;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { activate(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { activate(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { activate(currentIndex() + 1); });

    // Keyboard nav when the gallery has focus
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { activate(currentIndex() - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { activate(currentIndex() + 1); e.preventDefault(); }
    });
  });

  // ---------- PDP variant picker (live swap of variant id + price) ----------
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var picker = form.querySelector('[data-variant-picker]');
    if (!picker) return;
    var variants;
    try { variants = JSON.parse(form.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }
    if (!variants.length) return;

    var idInput  = form.querySelector('[data-variant-id]');
    var priceEl  = form.querySelector('[data-pdp-price]');
    var ctaPrice = form.querySelector('[data-cta-price]');
    var compareEl = form.querySelector('[data-pdp-compare]');
    var price3xEl = form.querySelector('[data-pdp-price-3x]');
    var addBtn   = form.querySelector('[data-add-to-cart]');

    // Build initial selected options array from active buttons.
    var selected = [];
    picker.querySelectorAll('.variant-options').forEach(function (row, i) {
      var active = row.querySelector('.variant-opt.active');
      selected[i] = active ? active.getAttribute('data-option-value') : null;
    });

    function money(cents) {
      // Format cents → "1 299 €" (matches FR-FR locale, EUR).
      var euros = (cents / 100);
      var parts = euros.toFixed(2).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      var dec = parts[1] === '00' ? '' : ',' + parts[1];
      return whole + dec + ' €';
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === selected[i]; });
      });
    }

    // Variant → metafields map (built by Liquid in main-product.liquid).
    // Each entry has range/speed/weight/power (formatted strings) plus
    // range_level/speed_level/power_level (0-10) for the spec radar bars.
    var variantsMeta;
    try { variantsMeta = JSON.parse(form.getAttribute('data-variants-meta') || '{}'); }
    catch (e) { variantsMeta = {}; }

    function splitValue(raw) {
      // "70 km" → { num: "70", unit: "km" }
      // "2×1500W" → { compact: true, raw: "2×1500W" }
      if (raw == null || raw === '') return { num: '', unit: '' };
      var s = String(raw).trim();
      if (s.indexOf('×') !== -1 || /\bou\b/.test(s) || s.indexOf(' / ') !== -1) {
        return { compact: true, raw: s };
      }
      var parts = s.split(/\s+/);
      var num = parts.shift();
      // Strip trailing letters that are stuck to the number (e.g. "800W").
      var m = /^([\d.,]+)(.*)$/.exec(num);
      if (m && m[2]) {
        return { num: m[1], unit: (m[2] + ' ' + parts.join(' ')).trim() };
      }
      return { num: num || '', unit: parts.join(' ') };
    }

    function updateSpecs(v) {
      // Look up variant metafields by id. If not present (legacy single-variant
      // product or merchant hasn't set per-variant data), leave the rendered
      // values alone.
      var meta = variantsMeta[v.id];
      if (!meta) return;

      ['range', 'speed', 'weight', 'power'].forEach(function (key) {
        var raw = meta[key];
        // Update EVERY copy of this spec (the strip is rendered twice: under the
        // gallery on desktop, after the buy box on mobile).
        var numEls  = document.querySelectorAll('[data-spec-num="' + key + '"]');
        var unitEls = document.querySelectorAll('[data-spec-unit="' + key + '"]');
        if (!numEls.length) return;

        var parts = splitValue(raw);
        numEls.forEach(function (numEl) {
          if (parts.compact) { numEl.textContent = parts.raw; numEl.classList.add('val-compact'); }
          // Specs without a separate unit element (range/speed/tire/load/slope) keep
          // their unit inline ("100 km"); only split when a unit element exists.
          else { numEl.textContent = unitEls.length ? parts.num : raw; numEl.classList.remove('val-compact'); }
        });
        unitEls.forEach(function (unitEl) {
          if (parts.compact) { unitEl.textContent = ''; unitEl.hidden = true; }
          else { unitEl.textContent = parts.unit; unitEl.hidden = false; }
        });
      });

      // Spec radar bars (legacy section, if present on the page)
      ['range', 'speed', 'power'].forEach(function (key) {
        var level = parseFloat(meta[key + '_level']) || 0;
        var fill = document.querySelector('[data-radar-fill="' + key + '"]');
        var valEl = document.querySelector('[data-radar-val="' + key + '"]');
        if (fill) fill.style.width = Math.max(0, Math.min(100, level * 10)) + '%';
        if (valEl && meta[key]) valEl.textContent = meta[key];
      });
      // Weight bar is inverse (lighter = better)
      var wRaw = meta.weight;
      if (wRaw) {
        var wMatch = /[\d.]+/.exec(wRaw);
        var wNum = wMatch ? parseFloat(wMatch[0]) : 0;
        var wPct = Math.max(10, Math.min(100, Math.round((50 - wNum) / 50 * 100)));
        var wFill = document.querySelector('[data-radar-fill="weight"]');
        var wVal  = document.querySelector('[data-radar-val="weight"]');
        if (wFill) wFill.style.width = wPct + '%';
        if (wVal)  wVal.textContent = wRaw;
      }

      // Index de Performance card (old-store style): update the data
      // attributes so the active tab + future tab clicks read fresh values,
      // then re-render the currently-active tab.
      var perf = document.querySelector('[data-perf-index]');
      if (perf) {
        if (meta.speed_level != null) perf.setAttribute('data-speed', meta.speed_level);
        if (meta.power_level != null) perf.setAttribute('data-power', meta.power_level);
        if (meta.range_level != null) perf.setAttribute('data-range', meta.range_level);
        if (meta.speed != null) perf.setAttribute('data-speed-value', meta.speed);
        if (meta.power != null) perf.setAttribute('data-power-value', meta.power);
        if (meta.range != null) perf.setAttribute('data-range-value', meta.range);
        if (typeof window.__flairideRenderPerf === 'function') window.__flairideRenderPerf();
      }
    }

    function syncUI() {
      var v = findVariant();
      if (!v) return;
      if (idInput)  idInput.value = v.id;
      if (priceEl)  priceEl.textContent = money(v.price);
      if (ctaPrice) ctaPrice.textContent = money(v.price);
      if (price3xEl) price3xEl.textContent = money(Math.round(v.price / 3));
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (v.available) {
          addBtn.removeAttribute('disabled');
          addBtn.style.opacity = '';
        } else {
          addBtn.setAttribute('disabled', '');
          addBtn.style.opacity = '0.5';
        }
      }
      updateSpecs(v);
    }

    picker.querySelectorAll('[data-variant-option]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pos = parseInt(btn.getAttribute('data-option-position'), 10);
        var val = btn.getAttribute('data-option-value');
        selected[pos] = val;

        // Update active state in this row
        var row = btn.parentElement;
        row.querySelectorAll('[data-variant-option]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        // Update displayed selected label
        var label = form.querySelector('[data-option-selected-' + pos + ']');
        if (label) label.textContent = val;

        syncUI();
      });
    });
  });

  // ---------- Native share API (PDP) ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-url');
    var title = btn.getAttribute('data-share-title');
    if (navigator.share) {
      navigator.share({ url: url, title: title }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var orig = btn.querySelector('span').textContent;
        btn.querySelector('span').textContent = 'Lien copié ✓';
        setTimeout(function () { btn.querySelector('span').textContent = orig; }, 1800);
      });
    }
  });

  // ---------- Keep --usp-h CSS var in sync with the actual USP strip height ----------
  // The hero uses calc(100vh - 38px - var(--usp-h, 92px)). On mobile the USP becomes
  // a 2×2 grid and ~doubles in height; this observer recomputes so the hero shrinks accordingly.
  (function () {
    function updateUspH() {
      var usp = document.querySelector('.usp');
      if (!usp) return;
      document.documentElement.style.setProperty('--usp-h', usp.offsetHeight + 'px');
    }
    window.addEventListener('resize', updateUspH, { passive: true });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateUspH);
    } else {
      updateUspH();
    }
  })();

  // ---------- Newsletter inline ----------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-newsletter-form]');
    if (!form) return;
    // Let Shopify handle it natively (customer create) — just add visual feedback
    form.classList.add('submitting');
  });
})();
